export default __webpack_public_path__ + "static/media/conteudo_extra_12_24.ef98211f.jpg";